import { styled, Typography } from '@mui/material';

export const StudyOpportunitiesWrapper = styled('div')({
  margin : '57px 0',
});

export const StudyOpportunitiesHeader = styled('div')({
  display        : 'flex',
  justifyContent : 'space-between',
  alignItems     : 'center',
  marginBottom   : '13px',
});

export const Title = styled(Typography)({
  fontFamily    : 'Montserrat',
  fontWeight    : '700',
  textTransform : 'uppercase',
});

export const StudyOpportunitiesContent = styled('div')(
  ({ theme, isEmpty }) => ({
    margin     : '24px auto',
    background : isEmpty ? theme.palette.primary.white : 'transparent',
    padding    : '0px 0px',
  })
);

export const StudyOpportunitiesList = styled('div')({
  display    : 'flex',
  alignItems : 'stretch',
  gap        : '16px',
  flexWrap   : 'nowrap',
  width      : '100%',
  overflow   : 'auto',
});
